import IFindAll from '../dtos/IFindAll'
import VeiculoPaginate from '../entities/VeiculoPaginate'
import IVeiculosRepository from '../repositories/IVeiculosRepository'

export interface IListVeiculosImpl {
  execute(params: IFindAll): Promise<VeiculoPaginate>
}

export default class ListVeiculosImpl implements IListVeiculosImpl {
  constructor(private readonly veiculosRepository: IVeiculosRepository) {}

  public async execute(params: IFindAll): Promise<VeiculoPaginate> {
    return this.veiculosRepository.findAll(params)
  }
}
